import topic from '../topic';
export const colrAPI = {
  getColrs: topic.colrTopic + '/get_colrs',
  editColr: topic.colrTopic + '/edit_colr',
  editColrs: topic.colrTopic + '/edit_colrs',
  getColrClassByPantone: topic.colrTopic + '/get_colr_class_by_pantone'
};
